module.exports = __webpack_public_path__ + "static/media/IMG_3278.83ced63b.JPG";